// extracted by mini-css-extract-plugin
export default {"list-loader__container":"styles_list-loader__container__FwJCq","list-loader__spinner":"styles_list-loader__spinner__xCZbY","spinner":"styles_spinner__6-l8H"};